import type { FunctionReturnType } from 'convex/server';
import { api, convexClient } from './convex';
import { addDeviceToken, findDeviceTokenKey, getDeviceToken, removeDeviceToken } from './tokens';

export type BoundDevice = FunctionReturnType<typeof api.devices.bindAsOwner>;

/**
 * Stores a freshly minted device token for its circle, the way the join flow does: an earlier token
 * of this circle on this device is signed out server-side and its entry (possibly under an older
 * bare-slug key) replaced. Returns the storage key (the circle identifier).
 */
export function storeBoundDevice(res: BoundDevice): string {
  const circleKey = res.circle.publicId;
  const previousKey = findDeviceTokenKey(res.circle.id);
  const previous = previousKey ? getDeviceToken(previousKey) : null;
  if (previous && previous.token !== res.deviceToken) {
    convexClient.mutation(api.devices.leave, { deviceToken: previous.token }).catch(() => {});
  }
  if (previousKey && previousKey !== circleKey) removeDeviceToken(previousKey);
  addDeviceToken(circleKey, {
    token: res.deviceToken,
    circleId: res.circle.id,
    circleName: res.circle.name,
    memberId: res.member.id,
    memberName: res.member.name,
  });
  return circleKey;
}
